import { Editor } from 'roosterjs-editor-core';

// Helper function in operateContent for the HTML, editor not yet initialized case
// Created primarily for testing
export default function createTempHtmlEditor(contentDiv: HTMLDivElement, initialContent: string) {
    return new Editor(contentDiv, { initialContent: initialContent });
}
